import {
  Box,
  Button,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  IconButton,
  Paper,
  Stack,
  Typography,
  InputBase,
  Tooltip,
  ClickAwayListener
} from '@mui/material';
import { GridColumns, useGridApiRef } from '@mui/x-data-grid-pro';
import React, { useEffect, useState } from 'react';
import { DateTimePicker, LocalizationProvider } from '@mui/x-date-pickers';
import '../studylogStyles.scss';
import EditIcon from '@mui/icons-material/Edit';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useAppSelector } from 'src/store';
import { useGetAssigneesMutation } from 'src/services/Utils';
import { usePreferedDateFormat } from 'src/util/DateFormatter';
import { usePermissionWrapper } from 'src/components/hooks/usePermissionWrapper';
import { useUser } from 'src/components/hooks/useUser';
import Loader from 'src/components/common/Loader';
import { PopupComponent } from 'src/components/common/PopupComponent';
import { useSelectedAppInfo } from 'src/util/SelectedAppInfo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { useAppDispatch } from 'src/store/hooks';
import { setMessage } from 'src/store/Message';
import CheckIcon from '@mui/icons-material/Check';
import { useMonitoringVisitLog } from './useMonitoringVisitLog';
import MonitoringVisitAuditTrail from './MonitoringVisitAuditTrail';
import { archLevel } from 'src/data/config';
import dayjs from 'dayjs';
import { UI_TIME_ZONE } from 'src/constants/formats';
import { useGetCodeListDataQuery } from 'src/services/codeList';
import VisitLogEditDialog from './VisitLogEditDialog';
import { MonitoringVisitLogType } from 'src/types/MonitoringVisitLogType';
import { useGetServerDateTimeMutation } from 'src/services/Utils';
import { useFieldTranslation } from 'src/components/fields/useFieldTranslation';
import ESignConsentReAuth from 'src/components/common/ESignConsentReAuth';
import { useLazySetESignQuery } from 'src/services/ESignAPI';
import { useValidUserForReAuth } from 'src/components/hooks/useValidUserForReAuth';
import { DataTable } from '@pihealth/common-ui-library';
import { GridToolbarExport } from '@mui/x-data-grid-pro';
import moment from 'moment';
export default function MonitoringVisit({ setStudyLogOpen, setMonitoringVisitOpen, text }: any) {
  const { isValidUserForReAuth } = useValidUserForReAuth();
  const [openSignConsent, setOpenSignConsent] = useState(false);
  const [signControlObject, setSignControlObject] = useState({
    site: { is_investigator_sign: false, id: '' },
    sponsor: { is_representative_sign: false, id: '' }
  });
  const apiRef = useGridApiRef();
  const dispatch = useAppDispatch();
  const { user } = useUser();
  const studyId: any = useAppSelector(state => state.site.selectedStudy);
  const selectedCountry = useAppSelector(state => state.site.selectedCountry);
  const selectedSite = useAppSelector(state => state.site.selectedSite);
  const { checkPermission } = usePermissionWrapper();
  const { selectedApp } = useSelectedAppInfo();
  const currentApp = selectedApp === process.env.REACT_APP_STUDYCONDUCT_SLUG ? 'CONDUCT' : 'STARTUP';
  const appPermission =
    currentApp === 'CONDUCT'
      ? !checkPermission('update_conduct_monitoring_visit_log')
      : !checkPermission('update_startup_monitoring_visit_log');

  const [openConfirm, setOpen] = React.useState(false);
  const [dataGridShow, setDataGridShow] = useState(false);
  const [visitRows, setRows] = useState<any>([]);
  const [isOpen, setIsOpen] = useState(false);
  const [auditUsersList, setAuditUsersList] = useState([]);
  const [auditId, setAuditId] = useState([]);
  const [anchorEl, setAnchorEl] = React.useState({ check_in: null, check_out: null });
  const initCheckInCheckOutObj = {
    init_check_in: { visit_type: '', id: '', start_date: '' },
    init_check_out: { visit_type: '', id: '', actual_start_date: '' }
  };
  const [checkInDeatils, setCheckInDetails] = useState(initCheckInCheckOutObj.init_check_in);
  const [checkOutDeatils, setCheckOutDetails] = useState(initCheckInCheckOutObj.init_check_out);
  const [rowData, setRowdata] = useState<any>({});
  const [disablePublish, setDisablePublish] = useState<boolean>(false);
  const [sponsorSign, setSponsorSign] = useState<boolean>(false);

  const { data: visitTypesList } = useGetCodeListDataQuery('VISITTYPE');
  const { data: subVisitTypesList } = useGetCodeListDataQuery('SUBTYPEVISIT');
  const [visitLogDialogIsOpen, setVisitLogDialogIsOpen] = useState(false);
  const [selectedVisitLog, setSelectedVisitLog] = useState({} as MonitoringVisitLogType);
  const { applicationModuleSection } = useFieldTranslation();
  const [pageSize, setPageSize] = React.useState(10);
  const [rowsCount, setRowsCount] = useState(0);
  const [pageNumber, setPageNumber] = useState(0);
  const [getServerDateTime] = useGetServerDateTimeMutation();
  const [filterObject, setFilterObject] = useState<any>({});

  const handleCheckInClick = (event: any, params: any) => {
    if (!isOpen) {
      setIsOpen(true);
      setAnchorEl({ ...anchorEl, check_in: event.currentTarget });
      setCheckInDetails(params.row);
    } else {
      setIsOpen(false);
      setAnchorEl({ check_in: null, check_out: null });
      setCheckInDetails(initCheckInCheckOutObj.init_check_in);
    }
    setCheckOutDetails(initCheckInCheckOutObj.init_check_out);
  };

  const handleCheckinDateOutsideClick = () => {
    if (anchorEl.check_in) {
      setAnchorEl({ ...anchorEl, check_in: null });
      if (isOpen) {
        setCheckInDetails(initCheckInCheckOutObj.init_check_in);
        setIsOpen(false);
      }
    }
  };
  const handleCheckOutDateOutsideClick = () => {
    if (anchorEl.check_out) {
      setAnchorEl({ ...anchorEl, check_out: null });
      if (openCheckoutPopup) {
        handleCalClose();
        setCheckOutDetails(initCheckInCheckOutObj.init_check_out);
      }
    }
  };
  const handleCalClose = () => {
    setIsOpen(false);
    setOpenCheckoutPopup(false);
  };

  const {
    monitoringVisitData,
    monitoringVisitError,
    monitoringVisitIsError,
    monitoringVisitIsLoading,
    monitoringVisitIsSuccess,
    getAllMonitoringVisits,
    updatePurposeIsError,
    updatePurposeError,
    updatePurposeIsSuccess,
    updatePurposeIsLoading,
    updateVisitPurpose,
    imvCheckInError,
    imvCheckInIsError,
    imvCheckInIsLoading,
    imvCheckInIsSuccess,
    imvCheckIn,
    imvCheckOutError,
    imvCheckOutIsError,
    imvCheckOutIsLoading,
    imvCheckOutIsSuccess,
    imvCheckOut,
    sqCheckInIsError,
    sqCheckInIsLoading,
    sqCheckInIsSuccess,
    sqCheckIn,
    siCheckInIsError,
    siCheckInIsLoading,
    siCheckInIsSuccess,
    siCheckIn,
    investigatorSignError,
    investigatorSignIsError,
    representativeSignError,
    representativeSignIsError,
    mvPublishToIsfError,
    mvPublishToIsfIsError,
    mvPublishToIsfIsSuccess,
    mvPublishToIsf,
    mvPublishToEtmfError,
    mvPublishToEtmfIsError,
    mvPublishToEtmfIsSuccess,
    mvPublishToEtmf
  } = useMonitoringVisitLog();
  const [setESignature, { isLoading: eSignatureIsLoading }] = useLazySetESignQuery();
  const [
    getAssignees,
    { isLoading: isAssingeeLoading, data: assignees, isError: isAssingeeError, isSuccess: isAssingeeSuccess }
  ] = useGetAssigneesMutation();
  const { userPreferedDateFormat, getPreferredDateTimeInLocal } = usePreferedDateFormat();
  const [openAuditTrail, setopenAuditTrail] = React.useState(false);
  const currentHierarchyLevel = useAppSelector(state => state.site.currentHierarchyLevel);
  const isHierarchyLevelClosed: boolean = useAppSelector(state => state.site.isHierarchyLevelClosed);
  const [openCheckoutPopup, setOpenCheckoutPopup] = useState(false);

  //new code for editable text
  const [inputFocused, setInputFocused] = useState(false);
  const [visitPurpose, setVisitPurpose] = useState('');
  const [preVPValue, setPreVPValue] = useState('');
  const [disableVP, setDisableVP] = useState(false);

  const handlePaperClick = (params: any) => {
    setId(params.row.id);
  };

  useEffect(() => {
    getAssignees({
      client_name: 'ctms-ui',
      data: [
        'VIEWCONDUCT_MONITORIG_VISITLOGS',
        'VIEWSTARTUP_MONITORIG_VISITLOGS',
        'UPDATESTARTUP_MONITORING_VISITLOGS',
        'UPDATECONDUCT_MONITORING_VISITLOGS'
      ]
    });
  }, []);
  const handleInputBlur = (e: any) => {
    if (visitPurpose === e.target.value) {
      setInputFocused(true);
    } else {
      setInputFocused(false);
    }
  };

  const handleInputFocus = (e: any, params: any) => {
    setInputFocused(true);
  };

  const handlePurposeEdit = async () => {
    if (visitPurpose === '' && preVPValue === '') {
      setDisableVP(true);
      return;
    } else {
      setDataGridShow(true);
      const data = {
        id: visitId,
        visit_purpose: visitPurpose
      };
      await updateVisitPurpose({
        visit_id: visitId,
        site_id: selectedSite,
        study_id: studyId,
        country: selectedCountry,
        application_section: currentApp,
        data
      });
      setPreVPValue('');
      setInputFocused(false);
    }
  };
  const handleMonitoringVisitsSign = async (data: any = {}) => {
    if (data.success) {
      if (!isValidUserForReAuth(data.records.user_name)) {
        dispatch(setMessage({ msgDetails: `Please e-sign with the logged in username`, severity: 'error' }));
      } else {
        setOpenSignConsent(false);
        let dataObj = {
          username: data.records.user_name,
          password: data.records.password,
          module_name: applicationModuleSection.monitoringEvent,
          name_of_signature: '',
          name_of_date_field: '',
          id: '',
          columns_to_change: {}
        };
        if (signControlObject.site.is_investigator_sign) {
          dataObj = {
            ...dataObj,
            name_of_signature: 'site_level_signed_by',
            name_of_date_field: 'site_level_signed_on',
            id: signControlObject.site.id,
            columns_to_change: {
              ...dataObj.columns_to_change,
              reason_for_site_level_sign: data.records.sign_reason
            }
          };
        } else if (signControlObject.sponsor.is_representative_sign) {
          dataObj = {
            ...dataObj,
            name_of_signature: 'sponsor_level_signed_by',
            name_of_date_field: 'sponsor_level_signed_on',
            id: signControlObject.sponsor.id,
            columns_to_change: {
              ...dataObj.columns_to_change,
              reason_for_sponsor_level_sign: data.records.sign_reason
            }
          };
        }
        const signatureResponse: any = await setESignature({
          site_id: selectedSite,
          study_id: studyId,
          country: selectedCountry,
          application: archLevel == 'sponsor' ? process.env.REACT_APP_NAME : process.env.REACT_APP_NAME_TEMP,
          application_section: currentApp,
          application_module_section: applicationModuleSection.studyLogs,
          data: dataObj
        });
        if (signatureResponse.isSuccess) {
          dispatch(
            setMessage({
              msgDetails: 'Sign Completed',
              severity: 'success'
            })
          );
          if (signControlObject.site.is_investigator_sign) {
            setSponsorSign(false);
          }
          setSignControlObject({
            ...signControlObject,
            site: { ...signControlObject.site, is_investigator_sign: false, id: '' },
            sponsor: { ...signControlObject.sponsor, is_representative_sign: false, id: '' }
          });
          callGetMonitoringVisitsList(pageNumber * pageSize, pageSize);
        } else if (signatureResponse.isError) {
          dispatch(setMessage({ msgDetails: `Authorization for ${data.records.user_name} failed`, severity: 'error' }));
        }
      }
      setDataGridShow(false);
    }
  };
  useEffect(() => {
    !openSignConsent && setDataGridShow(false);
  }, [openSignConsent]);
  const handleInvestigatorSign = async (params: any) => {
    setOpenSignConsent(true);
    setSignControlObject({
      ...signControlObject,
      site: { ...signControlObject.site, is_investigator_sign: true, id: params.row.id },
      sponsor: { ...signControlObject.sponsor, is_representative_sign: false, id: '' }
    });
    setDataGridShow(true);
  };

  const handleRepresentativeSign = async (params: any) => {
    setOpenSignConsent(true);
    setSignControlObject({
      ...signControlObject,
      site: { ...signControlObject.site, is_investigator_sign: false, id: '' },
      sponsor: { ...signControlObject.sponsor, is_representative_sign: true, id: params.row.id }
    });
    setDataGridShow(true);
    setRowdata(params.row);
  };

  const handleKeyDownEdit = (e: React.KeyboardEvent<HTMLInputElement>) => {
    e.stopPropagation();
    if (e.key === '') {
      e.preventDefault();
    }
  };

  const [visitId, setId] = useState('');

  const handleCheckOutPopup = (event: any, params: any) => {
    if (!openCheckoutPopup) {
      setOpen(true);
      setAnchorEl({ ...anchorEl, check_out: event.currentTarget });
      setCheckOutDetails(params.row);
    } else {
      setOpenCheckoutPopup(false);
      setAnchorEl({ check_in: null, check_out: null });
      setCheckOutDetails(initCheckInCheckOutObj.init_check_out);
    }
    setCheckInDetails(initCheckInCheckOutObj.init_check_in);
  };

  const handleRowData = (data: any) => {
    setRowdata(data);
    setSponsorSign(data.sponsor_level_signed_by === null ? true : false);
    if (data.is_isf_published !== true && archLevel === 'site') {
      setDisablePublish(false);
    }
    if (data.is_tmf_published !== true && archLevel === 'sponsor') {
      setDisablePublish(false);
    }
  };

  const formatDate = (params: any) => {
    if (params.value) {
      return `${moment(params.value).format(`${userPreferedDateFormat.toUpperCase()} LT`)}`;
    }
    return params.value;
  };
  const formatSignedBy = (signedBy: string, signedOn: string, reason: string, valueGetter = false) => {
    if (signedBy && signedBy.length > 0) {
      if (!valueGetter) {
        return (
          <span className="signedInfo">
            Signed by{' '}
            <Tooltip
              title={
                signedBy.length > 16 ? (
                  <div>
                    {signedBy} <br /> on {getPreferredDateTimeInLocal(signedOn)}
                  </div>
                ) : null
              }
            >
              <strong>{`${signedBy} `}</strong>
            </Tooltip>{' '}
            on <span color="text.secondary">{`${getPreferredDateTimeInLocal(signedOn)}`}</span> <br />
            <span className="signReasonrow">
              <span color="text.secondary">Reason:</span> &ldquo;{`${reason} `}
              &rdquo;
            </span>
          </span>
        );
      } else {
        return `Signed by ${signedBy} on ${getPreferredDateTimeInLocal(signedOn)}, Reason: ${reason}`;
      }
    }
  };
  const checkInDateValue = null;
  const checkoutDateValue = null;

  const columns: GridColumns = [
    { field: 'visit_no', headerName: 'Visit Number', minWidth: 100, flex: 1, type: 'number' },
    { field: 'visit_name', headerName: 'Visit Type', minWidth: 150, flex: 1 },
    { field: 'sub_type', headerName: 'Subtype', minWidth: 150, flex: 1 },
    {
      field: 'planned_range',
      headerName: 'Planned Range',
      type: 'date',
      minWidth: 150,
      flex: 1
      // valueGetter: formatDate
    },
    {
      field: 'start_date',
      headerName: 'Schedule Start Date',
      type: 'date',
      minWidth: 200,
      flex: 1,
      valueGetter: formatDate
    },
    {
      field: 'end_date',
      headerName: 'Schedule End Date',
      type: 'date',
      minWidth: 200,
      flex: 1,
      valueGetter: formatDate
    },
    {
      field: 'actual_start_date',
      headerName: 'Actual Start Date',
      minWidth: 200,
      flex: 1,
      renderCell: (params: any) => {
        if (params.row.actual_start_date === null) {
          return (
            <>
              {' '}
              <ClickAwayListener key={`${params.row.id}0`} onClickAway={handleCheckinDateOutsideClick}>
                <div>
                  <Button
                    size="small"
                    variant="contained"
                    onClick={e => {
                      e.stopPropagation();
                      handleCheckInClick(e, params);
                    }}
                    disabled={archLevel === 'site' ? true : appPermission}
                  >
                    Check In
                  </Button>
                  {checkInDeatils.id === params.row.id && isOpen && (
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <div onClick={e => e.stopPropagation()}>
                        <DateTimePicker
                          PopperProps={{ placement: 'bottom-end', anchorEl: anchorEl.check_in }}
                          open={isOpen}
                          label="Controlled picker"
                          value={checkInDateValue}
                          onChange={newValue => {
                            //console.log(newValue)
                          }}
                          onAccept={(newValue: any) => {
                            handleCheckInDate(newValue);
                          }}
                          maxDateTime={dayjs(new Date())}
                          minDateTime={dayjs(checkInDeatils?.start_date)}
                          renderInput={({ ref, inputProps, disabled, onChange, value, ...other }) => <div />}
                        />
                      </div>
                    </LocalizationProvider>
                  )}
                </div>
              </ClickAwayListener>
            </>
          );
        } else {
          return `${moment(params.row.actual_start_date).format(`${userPreferedDateFormat.toUpperCase()} LT`)}`;
        }
      },
      valueGetter: formatDate
    },
    {
      field: 'actual_end_date',
      headerName: 'Actual End Date',
      minWidth: 200,
      flex: 1,
      renderCell: (params: any) => {
        if (params.row.actual_end_date === null) {
          return (
            <>
              <Button
                size="small"
                variant="contained"
                onClick={e => {
                  e.stopPropagation();
                  handleCheckOutPopup(e, params);
                }}
                disabled={
                  archLevel === 'site' ? true : appPermission || params.row.actual_start_date === null ? true : false
                }
              >
                Check Out
              </Button>
              <ClickAwayListener key={`${params.row.id}1`} onClickAway={handleCheckOutDateOutsideClick}>
                <div>
                  {checkOutDeatils.id === params.row.id && openCheckoutPopup && (
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <div onClick={e => e.stopPropagation()}>
                        <DateTimePicker
                          PopperProps={{ placement: 'bottom-end', anchorEl: anchorEl.check_out }}
                          open={openCheckoutPopup}
                          value={checkoutDateValue}
                          onChange={newValue => {
                            //console.log(newValue)
                          }}
                          onAccept={(newValue: any) => {
                            handleCheckOutDate(newValue);
                          }}
                          onClose={() => handleCalClose()}
                          maxDateTime={dayjs(new Date())}
                          minDateTime={dayjs(checkOutDeatils?.actual_start_date)}
                          renderInput={({ ref, inputProps, disabled, onChange, value, ...other }) => <div />}
                        />
                      </div>
                    </LocalizationProvider>
                  )}
                </div>
              </ClickAwayListener>
            </>
          );
        } else {
          return `${moment(params.row.actual_end_date).format(`${userPreferedDateFormat.toUpperCase()} LT`)}`;
        }
      },
      valueGetter: formatDate
    },
    {
      field: 'site_level_signed_by',
      headerName: 'Investigator or Representative Signature',
      minWidth: 420,
      flex: 1,
      renderCell: (params: any) => {
        let siteSignPermission: any;
        if (params.row.visit_type === 'Site Initiation Visit') {
          siteSignPermission = checkPermission('site_sign_si_visit');
        }
        if (params.row.visit_type === 'Site Qualification Visit') {
          siteSignPermission = checkPermission('site_sign_sq_letter');
        }
        if (params.row.visit_type === 'Interim Monitoring Visit') {
          siteSignPermission = checkPermission('site_sign_site_interim_monitoring_visit');
        }

        if (params.row.site_level_signed_by === null) {
          return (
            <Button
              size="small"
              variant="contained"
              disabled={archLevel !== 'site' ? true : params.row.actual_end_date === null ? true : !siteSignPermission}
              onClick={() => handleInvestigatorSign(params)}
            >
              Sign
            </Button>
          );
        } else {
          return (
            <div className="MuiDataGrid-cellContent">
              {formatSignedBy(
                params.row.site_level_signed_by,
                params.row.site_level_signed_on,
                params.row.reason_for_site_level_sign
              )}
            </div>
          );
        }
      },
      valueGetter: (params: any) => {
        return formatSignedBy(
          params.row.site_level_signed_by,
          params.row.site_level_signed_on,
          params.row.reason_for_site_level_sign,
          true
        );
      }
    },
    {
      field: 'sponsor_level_signed_by',
      headerName: 'Site Monitor, Sponsor or Representative Signature',
      minWidth: 420,
      flex: 1,
      renderCell: (params: any) => {
        let sponsorSignPermission: any;
        if (params.row.visit_type === 'Site Initiation Visit') {
          sponsorSignPermission = checkPermission('sponsor_sign_si_visit');
        }
        if (params.row.visit_type === 'Site Qualification Visit') {
          sponsorSignPermission = checkPermission('sponsor_sign_sq_letter');
        }
        if (params.row.visit_type === 'Interim Monitoring Visit') {
          sponsorSignPermission = checkPermission('sponsor_sign_site_interim_monitoring_visit');
        }
        if (params.row.sponsor_level_signed_by === null) {
          return (
            <Button
              size="small"
              variant="contained"
              disabled={
                archLevel !== 'site' ? (params.row.site_level_signed_by === null ? true : !sponsorSignPermission) : true
              }
              onClick={() => handleRepresentativeSign(params)}
            >
              Sign
            </Button>
          );
        } else {
          return (
            <div className="MuiDataGrid-cellContent">
              {formatSignedBy(
                params.row.sponsor_level_signed_by,
                params.row.sponsor_level_signed_on,
                params.row.reason_for_sponsor_level_sign
              )}
            </div>
          );
        }
      },
      valueGetter: (params: any) => {
        return formatSignedBy(
          params.row.sponsor_level_signed_by,
          params.row.sponsor_level_signed_on,
          params.row.reason_for_sponsor_level_sign,
          true
        );
      }
    },
    {
      field: 'visit_purpose',
      headerName: 'Visit Purpose',
      minWidth: 220,
      flex: 1,
      renderCell: (params: any) => {
        return (
          <div className="limitText">
            {archLevel !== 'site' && params.row.sponsor_level_signed_by === null ? (
              <Paper
                component="form"
                sx={{
                  p: '2px 2px',
                  display: 'flex',
                  alignItems: 'center',
                  border: `1px solid ${inputFocused ? '#87CEFA' : '#ccc'}`
                }}
                onClick={() => handlePaperClick(params)}
              >
                <Tooltip
                  title={
                    params.row.visit_purpose === null
                      ? ''
                      : params.row.visit_purpose.length > 28
                      ? params.row.visit_purpose
                      : ''
                  }
                >
                  <InputBase
                    sx={{ mx: 1, flex: 1 }}
                    inputProps={{
                      'aria-label': 'Click to edit',
                      onKeyDown: handleKeyDownEdit,
                      maxLength: 100
                    }}
                    defaultValue={params.row.visit_purpose || ''}
                    onBlur={(e: any) => handleInputBlur(e)}
                    onChange={(e: any) => {
                      setVisitPurpose(e.target.value);
                      setPreVPValue(params.row.visit_purpose);
                      if (e.target.value !== '') {
                        setDisableVP(false);
                      }
                    }}
                    onFocus={(e: any) => handleInputFocus(e, params)}
                    key={params.id}
                  />
                </Tooltip>
                {visitId === params.row.id ? (
                  <>
                    {' '}
                    {inputFocused && (
                      <IconButton
                        type="button"
                        sx={{ p: '10px' }}
                        aria-label="save"
                        onClick={handlePurposeEdit}
                        disabled={disableVP}
                      >
                        <CheckIcon />
                      </IconButton>
                    )}
                  </>
                ) : null}
              </Paper>
            ) : (
              <>
                {params.row.visit_purpose && params.row.visit_purpose.length > 32 ? (
                  <Tooltip title={params.row.visit_purpose}>
                    <Box className="limitText">{params.row.visit_purpose}</Box>
                  </Tooltip>
                ) : (
                  <>{params.row.visit_purpose === null ? '' : params.row.visit_purpose}</>
                )}
              </>
            )}
          </div>
        );
      }
    }
  ];

  const handleEditMonitoringVisit = (op: string, rowObj: any) => {
    setSelectedVisitLog(rowObj);
    setVisitLogDialogIsOpen(true);
  };

  archLevel === 'sponsor' &&
    columns.push({
      field: 'actions',
      type: 'actions',
      minWidth: 50,
      flex: 1,
      renderCell: (params: any) => {
        const isEditable =
          (params.row.visit_type === 'Site Qualification Visit' &&
            checkPermission('edit_site_qualification_monitoring_visit_log')) ||
          (params.row.visit_type === 'Site Initiation Visit' &&
            checkPermission('edit_site_initiation_monitoring_visit_log')) ||
          (params.row.visit_type === 'Interim Monitoring Visit' &&
            checkPermission('edit_interim_monitoringvisit_monitoring_visit_log'));
        return (
          <div>
            <IconButton
              onClick={e => handleEditMonitoringVisit('Edit', params.row)}
              disabled={params.row.sponsor_level_signed_by !== null || !isEditable}
            >
              <EditIcon />
            </IconButton>
            {/* <IconButton onClick={e => handleEditMonitoringVisit('Delete', params.row)} disabled>
              <DeleteIcon />
            </IconButton> */}
          </div>
        );
      }
    });

  const handleCheckInDate = async (value: any) => {
    const serverDateTime: any = await getServerDateTime();
    const checkInDate = moment.utc(value.$d).format();
    if (moment(checkInDate) > moment(`${serverDateTime.data}Z`)) {
      dispatch(
        setMessage({
          msgDetails: `Check-in date & time is not in sync with Server date & time.`,
          severity: 'error'
        })
      );
      return;
    } else {
      setIsOpen(false);
      switch (checkInDeatils.visit_type) {
        case 'Site Initiation Visit':
          await siCheckIn({
            visit_id: checkInDeatils.id,
            site_id: selectedSite,
            study_id: studyId,
            country: selectedCountry,
            application: 'CTMS',
            check_in_date: checkInDate,
            application_section: currentApp,
            application_module_section: 'SUBJECT TRACKING'
          });
          await imvCheckIn({
            visit_id: checkInDeatils.id,
            site_id: selectedSite,
            study_id: studyId,
            country: selectedCountry,
            application: 'CTMS',
            check_in_date: checkInDate,
            application_section: currentApp,
            application_module_section: 'SUBJECT TRACKING'
          });
          break;
        case 'Site Qualification Visit':
          await sqCheckIn({
            visit_id: checkInDeatils.id,
            site_id: selectedSite,
            study_id: studyId,
            country: selectedCountry,
            application: 'CTMS',
            check_in_date: checkInDate,
            application_section: currentApp,
            application_module_section: 'SUBJECT TRACKING'
          });
          await imvCheckIn({
            visit_id: checkInDeatils.id,
            site_id: selectedSite,
            study_id: studyId,
            country: selectedCountry,
            application: 'CTMS',
            check_in_date: checkInDate,
            application_section: currentApp,
            application_module_section: 'SUBJECT TRACKING'
          });
          break;
        default:
          await imvCheckIn({
            visit_id: checkInDeatils.id,
            site_id: selectedSite,
            study_id: studyId,
            country: selectedCountry,
            application: 'CTMS',
            check_in_date: checkInDate,
            application_section: currentApp,
            application_module_section: 'SUBJECT TRACKING'
          });
      }
    }
  };
  const handleCheckOutDate = async (value: any) => {
    const checkOutDate = moment.utc(value.$d).format();
    const serverDateTime: any = await getServerDateTime();
    if (moment(checkOutDate) > moment(`${serverDateTime.data}Z`)) {
      dispatch(
        setMessage({
          msgDetails: `Check-out date & time is not in sync with Server date & time.`,
          severity: 'error'
        })
      );
      return;
    } else {
      setIsOpen(false);
      setOpenCheckoutPopup(false);
      await imvCheckOut({
        visit_id: checkOutDeatils.id,
        site_id: selectedSite,
        study_id: studyId,
        country: selectedCountry,
        application: 'CTMS',
        check_out_date: checkOutDate,
        application_section: currentApp,
        application_module_section: 'SUBJECT TRACKING'
      });
    }
  };
  const getMonitoringVisitList = async (
    studyId: string | null,
    selectedCountry: string | null,
    selectedSite: string | null,
    from = -1,
    size = -1
  ) => {
    setDataGridShow(true);
    await getAllMonitoringVisits({
      site_id: selectedSite,
      study_id: studyId,
      country: selectedCountry,
      application_section: currentApp,
      from,
      size,
      data: filterObject
    });
  };

  const callGetMonitoringVisitsList = (from: number, size: number) =>
    getMonitoringVisitList(studyId, selectedCountry, selectedSite, from, size);

  const getEventsOnHierarchyLevel = (from: number, size: number) => {
    if (currentHierarchyLevel === 'site' && !isHierarchyLevelClosed) {
      callGetMonitoringVisitsList(from, size);
      // removed heirarchy
      setRowdata({});
    } else {
      getMonitoringVisitList(
        currentHierarchyLevel !== null ? studyId : null,
        currentHierarchyLevel !== 'study' && currentHierarchyLevel !== null ? selectedCountry : null,
        currentHierarchyLevel === 'site' ? selectedSite : null,
        from,
        size
      );
      setRowdata({});
    }
  };
  useEffect(() => {
    getEventsOnHierarchyLevel(0, 10);
  }, [currentHierarchyLevel, studyId, selectedCountry, selectedSite]);

  const refetch = () => {
    if (pageNumber * pageSize > rowsCount - 1) {
      setPageNumber(0);
      getAllMonitoringVisits({
        site_id: selectedSite,
        study_id: studyId,
        country: selectedCountry,
        application_section: currentApp,
        from: 0,
        size: pageSize,
        data: filterObject
      });
    } else {
      getAllMonitoringVisits({
        site_id: selectedSite,
        study_id: studyId,
        country: selectedCountry,
        application_section: currentApp,
        from: pageNumber * pageSize,
        size: pageSize,
        data: filterObject
      });
    }
  };
  const filterValues = (data: any) => {
    setFilterObject(data);
  };
  useEffect(() => {
    if (!monitoringVisitIsLoading && (pageSize === 10 || pageSize === 20 || pageSize === 30)) {
      refetch();
    }
  }, [pageNumber, pageSize, filterObject]);
  const handlePublishToEtmf = async () => {
    setDisablePublish(true);
    setDataGridShow(true);
    const dataObject = {
      monitoring_visit_id: rowData.id,
      time_zone_id: UI_TIME_ZONE,
      Planned_range: rowData.planned_range,
      update: false,
      is_tmf_published: true,
      updated_by: user
    };
    await mvPublishToEtmf({
      site_id: selectedSite,
      study_id: studyId,
      country: selectedCountry,
      application: archLevel === 'sponsor' ? process.env.REACT_APP_NAME : process.env.REACT_APP_NAME_TEMP,
      application_section: currentApp,
      application_module_section: 'SUBJECT TRACKING',
      data: dataObject
    });
  };

  const handlePublishToIsf = async () => {
    setDisablePublish(true);
    setDataGridShow(true);
    const dataObject = {
      monitoring_visit_id: rowData.id,
      time_zone_id: UI_TIME_ZONE,
      Planned_range: rowData.planned_range,
      update: false,
      is_isf_published: true,
      updated_by: user
    };
    await mvPublishToIsf({
      site_id: selectedSite,
      study_id: studyId,
      country: selectedCountry,
      application: archLevel === 'sponsor' ? process.env.REACT_APP_NAME : process.env.REACT_APP_NAME_TEMP,
      application_section: currentApp,
      application_module_section: 'SUBJECT TRACKING',
      data: dataObject
    });
  };

  useEffect(() => {
    if (monitoringVisitIsError || updatePurposeIsError) {
      // setting protocol and sponsor details
      if (!monitoringVisitData) {
        setRows([]);
        setRowsCount(0);
      }
      setDataGridShow(false);
      const err: any = monitoringVisitError || updatePurposeError;
      if (err?.status == 500) {
        dispatch(
          setMessage({
            msgDetails: `${err?.status} : Internal Server Error`,
            severity: 'error'
          })
        );
      } else if (err?.status == 403) {
        dispatch(
          setMessage({
            msgDetails: 'Error 403 Restricted User permission',
            severity: 'error'
          })
        );
      } else if (err?.status == 404) {
        return;
      }
    }
  }, [monitoringVisitIsError, updatePurposeIsError]);

  useEffect(() => {
    if (
      imvCheckInIsError ||
      sqCheckInIsError ||
      siCheckInIsError ||
      investigatorSignIsError ||
      representativeSignIsError ||
      imvCheckOutIsError
    ) {
      setDataGridShow(false);
      const err: any = investigatorSignError || representativeSignError || imvCheckInError || imvCheckOutError;
      if (err?.status == 500) {
        dispatch(
          setMessage({
            msgDetails: `${err?.status} : Internal Server Error`,
            severity: 'error'
          })
        );
      } else if (err?.status == 403) {
        dispatch(
          setMessage({
            msgDetails: 'Error 403 Restricted User permission',
            severity: 'error'
          })
        );
      } else if (err?.status == 404) {
        const errorMessage = err?.data?.context?.message;
        dispatch(
          setMessage({
            msgDetails: errorMessage ? errorMessage : 'No data',
            severity: 'error'
          })
        );
      }
    }
  }, [
    imvCheckInIsError,
    sqCheckInIsError,
    siCheckInIsError,
    investigatorSignIsError,
    representativeSignIsError,
    imvCheckOutIsError
  ]);

  useEffect(() => {
    if (mvPublishToEtmfIsError || mvPublishToIsfIsError) {
      if (!monitoringVisitData) {
        setRows([]);
      }
      setDataGridShow(false);
      const err: any = mvPublishToEtmfError || mvPublishToIsfError;
      if (err?.status == 500) {
        dispatch(
          setMessage({
            msgDetails: `${err?.status} : Internal Server Error`,
            severity: 'error'
          })
        );
      } else if (err?.status == 403) {
        dispatch(
          setMessage({
            msgDetails: 'Error 403 Restricted User permission',
            severity: 'error'
          })
        );
      } else if (err?.status == 422) {
        dispatch(
          setMessage({
            msgDetails: err?.data?.context.message,
            severity: 'error'
          })
        );
      } else if (err?.status == 404) {
        return;
      }
    }
  }, [mvPublishToEtmfIsError, mvPublishToIsfIsError]);
  useEffect(() => {
    if (monitoringVisitData && monitoringVisitIsSuccess && !monitoringVisitIsLoading) {
      (async () => {
        const tempRows: any = [];
        if (monitoringVisitData && monitoringVisitData.selected_data.length > 0) {
          monitoringVisitData.selected_data.map((visistData: any) => {
            const data = Object.assign({}, visistData);
            const startDate = moment(`${data.start_date}Z`).format('MM/DD');
            const endDate = moment(`${data.end_date}Z`).format('MM/DD');
            data.planned_range = `${startDate} - ${endDate}`;
            tempRows.push({
              ...data,
              start_date: `${data.start_date}Z`,
              end_date: `${data.end_date}Z`,
              actual_start_date: data.actual_start_date ? `${data.actual_start_date}Z` : data.actual_start_date,
              actual_end_date: data.actual_end_date ? `${data.actual_end_date}Z` : data.actual_end_date
            });
          });
        }
        setRowsCount(monitoringVisitData?.record_count);
        if (tempRows.length > 0) {
          setRows([]);
          setRows(tempRows);
          const auditIds = tempRows.map((ob: any) => ob.id);
          setAuditId(auditIds);
        } else {
          setRows([]);
          setAuditId([]);
        }
        setDataGridShow(false);
      })();
    }
  }, [monitoringVisitData, monitoringVisitIsSuccess, monitoringVisitIsLoading]);

  useEffect(() => {
    if (updatePurposeIsSuccess || mvPublishToEtmfIsSuccess || mvPublishToIsfIsSuccess) {
      const message = updatePurposeIsSuccess
        ? 'Visit Purpose Updated'
        : mvPublishToEtmfIsSuccess
        ? 'Published to eTMF Successfully'
        : mvPublishToIsfIsSuccess
        ? 'Published to eISF Successfully'
        : '';
      dispatch(
        setMessage({
          msgDetails: message,
          severity: 'success'
        })
      );
      setDataGridShow(false);
      callGetMonitoringVisitsList(pageNumber * pageSize, pageSize);
    }
  }, [updatePurposeIsSuccess, mvPublishToEtmfIsSuccess, mvPublishToIsfIsSuccess]);

  useEffect(() => {
    if (imvCheckInIsSuccess || sqCheckInIsSuccess || siCheckInIsSuccess) {
      dispatch(
        setMessage({
          msgDetails: 'Check In Date Updated',
          severity: 'success'
        })
      );
      callGetMonitoringVisitsList(pageNumber * pageSize, pageSize);
    }
  }, [imvCheckInIsSuccess, sqCheckInIsSuccess, siCheckInIsSuccess]);

  useEffect(() => {
    if (imvCheckOutIsSuccess) {
      dispatch(
        setMessage({
          msgDetails: 'Check Out Date Updated',
          severity: 'success'
        })
      );
      callGetMonitoringVisitsList(pageNumber * pageSize, pageSize);
    }
  }, [imvCheckOutIsSuccess]);

  useEffect(() => {
    if (!isAssingeeLoading && isAssingeeError) {
      dispatch(setMessage({ msgDetails: 'Unable to get assignees', severity: 'error' }));
    } else if (!isAssingeeLoading && isAssingeeSuccess && assignees) {
      const assignList: any = assignees.map((item: any) => `${item.first_name} ${item.last_name}`);
      setAuditUsersList(assignList);
    }
  }, [isAssingeeLoading, isAssingeeSuccess, assignees, isAssingeeError]);

  const handelBack = () => {
    setStudyLogOpen(true);
    setMonitoringVisitOpen(false);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const handleYes = () => {
    handleClose();
    setOpenCheckoutPopup(true);
  };

  const handleAuditTrail = () => {
    setopenAuditTrail(true);
  };

  let publishToEtmfPermission;
  if (rowData.visit_type === 'Site Qualification Visit') {
    if (rowData.is_tmf_published !== true && archLevel === 'sponsor') {
      publishToEtmfPermission = checkPermission('publish_etmf_site_qualification_visit');
    }
  }

  if (rowData.visit_type === 'Interim Monitoring Visit') {
    if (rowData.is_tmf_published !== true && archLevel === 'sponsor') {
      publishToEtmfPermission = checkPermission('publish_etmf_site_interim_monitoring_visit');
    }
  }
  if (rowData.visit_type === 'Site Initiation Visit') {
    if (rowData.is_tmf_published !== true && archLevel === 'sponsor') {
      publishToEtmfPermission = checkPermission('publish_etmf_site_initiation_visit');
    }
  }

  let publishToIsfPermission;
  if (rowData.visit_type === 'Site Qualification Visit') {
    if (rowData.is_isf_published !== true && archLevel === 'site') {
      publishToIsfPermission = checkPermission('publish_isf_site_qualification_visit');
    }
  }
  if (rowData.visit_type === 'Interim Monitoring Visit') {
    if (rowData.is_isf_published !== true && archLevel === 'site') {
      publishToIsfPermission = checkPermission('publish_isf_site_interim_monitoring_visit');
    }
  }
  if (rowData.visit_type === 'Site Initiation Visit') {
    if (rowData.is_isf_published !== true && archLevel === 'site') {
      publishToIsfPermission = checkPermission('publish_isf_site_initiation_visit');
    }
  }
  const dataTableProps = {
    apiRef,
    onRowClick: (params: any) => handleRowData(params.row),
    sx: {
      '& .MuiDataGrid-columnHeaderTitle': {
        whiteSpace: 'break-spaces !important',
        lineHeight: 1.3,
        '&:hover': {
          textOverflow: 'ellipsis'
        }
      }
    },
    filterMode: 'server'
  };
  const definedCustomDatGridExport = (exportFields: any = {}) => {
    return (
      <GridToolbarExport
        csvOptions={{
          fileName: `${`Monitoring Visit Log`} ${moment(new Date()).format(
            `${(userPreferedDateFormat.includes('/')
              ? userPreferedDateFormat.replaceAll('/', '_')
              : userPreferedDateFormat.replaceAll('-', '_')
            ).toUpperCase()} hh_mm A`
          )}`
        }}
      />
    );
  };
  return (
    <div>
      <Loader />

      {currentApp === 'CONDUCT' ? (
        <div>
          <Box className="mainBackBtnWrap" sx={{ mt: -1}}>
            <Button onClick={() => handelBack()} startIcon={<ArrowBackIcon fontSize="small" />}>
              LIST OF LOGS
            </Button>
          </Box>
          <Grid container spacing={2} alignItems="center" className="titleGrid">
            <Grid item xs>
              <Stack direction="row" spacing={4} alignItems="center">
                <Typography variant="h6" component="h6" sx={{ height: '35px' }}>
                  Monitoring Visit Log
                </Typography>
              </Stack>
            </Grid>
          </Grid>
        </div>
      ) : (
        <div style={{ marginBottom: '12px', marginTop: "-8px" }}>
          <Button onClick={() => handelBack()} startIcon={<ArrowBackIcon fontSize="small" />}>
            LIST OF LOGS
          </Button>
          / Monitoring Visit Log
        </div>
      )}
      <Grid
        container
        spacing={2}
        alignItems="center"
        className="titleGrid"
        justifyContent="flex-end"
        style={{ marginTop: '-64px' }}
      >
        {
          <Grid item sx={{ textAlign: 'right' }}>
            <Button
              variant="outlined"
              style={{ textTransform: 'none' }}
              onClick={handleAuditTrail}
              sx={{ mr: 2 }}
              disabled={!visitRows?.length}
            >
              View Audit Trail
            </Button>
            {archLevel !== 'site' ? (
              <Button
                variant="contained"
                style={{ textTransform: 'none' }}
                disabled={
                  !publishToEtmfPermission ||
                  sponsorSign ||
                  rowData.sponsor_level_signed_by === undefined ||
                  disablePublish
                }
                onClick={() => handlePublishToEtmf()}
              >
                PUBLISH TO eTMF
              </Button>
            ) : (
              <Button
                variant="contained"
                style={{ textTransform: 'none' }}
                disabled={
                  !publishToIsfPermission ||
                  sponsorSign ||
                  rowData.sponsor_level_signed_by === undefined ||
                  disablePublish
                }
                onClick={() => handlePublishToIsf()}
              >
                PUBLISH TO eISF
              </Button>
            )}
          </Grid>
        }
      </Grid>
      <Box
        sx={{
          height: '78vh',
          width: '100%',
          '@media (max-width:1367px)': {
            height: '68.5vh'
          }
        }}
      >
        <div style={{ display: 'flex', height: '100%' }}>
          <div style={{ flexGrow: 1 }}>
            <DataTable
              dataTableProps={dataTableProps}
              hasDefinedColumns
              columns={columns}
              height="76vh"
              rows={visitRows}
              setPageNumber={setPageNumber}
              datePreference={userPreferedDateFormat}
              paging
              pagination
              loading={
                dataGridShow ||
                updatePurposeIsLoading ||
                imvCheckInIsLoading ||
                imvCheckOutIsLoading ||
                sqCheckInIsLoading ||
                siCheckInIsLoading ||
                eSignatureIsLoading
              }
              className="studylogDatagrid"
              pinnedColumns={{ right: ['actions'] }}
              pageSize={pageSize}
              setPageSize={setPageSize}
              rowsCount={rowsCount}
              page={pageNumber}
              paginationMode="server"
              hasDefinedDataGridToolbarExport
              definedGridToolbarExport={definedCustomDatGridExport}
              filterValues={(data: any) => filterValues(data)}
            />
          </div>
        </div>
      </Box>
      {visitLogDialogIsOpen && (
        <VisitLogEditDialog
          isDialogOpen={visitLogDialogIsOpen}
          onClose={() => setVisitLogDialogIsOpen(false)}
          editableLog={selectedVisitLog}
          allVisitLogs={visitRows}
          visitTypesList={visitTypesList}
          subVisitTypesList={subVisitTypesList}
          onSuccess={() => callGetMonitoringVisitsList(pageNumber * pageSize, pageSize)}
        />
      )}
      <PopupComponent
        open={openConfirm}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className="confirm-modal"
      >
        <DialogTitle id="alert-dialog-title">{'Confirm'}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {checkOutDeatils.visit_type === 'Interim Monitoring Visit' &&
              'Are you sure the Interim Monitoring visit is over?'}
            {checkOutDeatils.visit_type === 'Site Qualification Visit' &&
              'Are you sure the Site Qualification visit is over?'}
            {checkOutDeatils.visit_type === 'Site Initiation Visit' &&
              'Are you sure the Site Initiation visit is over?'}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} className="grey-btn">
            NO
          </Button>
          <Button
            onClick={e => {
              e.stopPropagation();
              handleYes();
            }}
            autoFocus
          >
            YES
          </Button>
        </DialogActions>
      </PopupComponent>
      <PopupComponent
        open={openAuditTrail}
        maxWidth="md"
        // sx={{ '& .MuiDialog-paper': { maxWidth: 'unset !important' }, justifyContent: 'center', left: '150px' }}
      >
        <DialogTitle>Audit Trail</DialogTitle>
        <DialogContent className="audit-history-modal">
          <MonitoringVisitAuditTrail auditUsersList={auditUsersList} auditId={auditId} />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setopenAuditTrail(false)}>Close</Button>
        </DialogActions>
      </PopupComponent>
      {openSignConsent && (
        <ESignConsentReAuth
          openSignConsent={openSignConsent}
          setOpenSignConsent={setOpenSignConsent}
          handleConfirmSign={handleMonitoringVisitsSign}
        />
      )}
    </div>
  );
}
